import React, { useState } from "react";
import { Typography } from "@mui/material";

import CustomTabs from "../../components/custom-tabs/custom-tabs";
import { AdminConsoleStyled } from "./admin-console.styles";
import { ADMIN_TAB_LIST } from "./admin.utils";
import UserTable from "./users/users-lists/UserTable";
import RateCardTable from "./rateCard/rate-card-table";
import ServicesTable from "./service-groups/service-groups-table";

const AdminConsole = () => {
  const [activeTab, setActiveTab] = useState("users");

  return (
    <AdminConsoleStyled>
      <div className="title">
        <Typography variant="h5">Admin Console</Typography>
      </div>
      <div>
        <div className="box">
          <CustomTabs
            activeTab={activeTab}
            handleChange={setActiveTab}
            tabsList={ADMIN_TAB_LIST}
          />
          <div>
            {activeTab === "users" && <UserTable />}
            {activeTab === "service-groups" && <ServicesTable />}

            {activeTab === "rate-cards" && <RateCardTable />}
          </div>
        </div>
      </div>
    </AdminConsoleStyled>
  );
};

export default AdminConsole;
